<i18n locale="en">
{
  "labels": {
    "unknown": "Unknown Page"
  },
  "actions": {
    "add-page": "Add Page"
  }
}
</i18n>

<template>
  <div>
    <OwnOption
      v-if="actionConfig?.params?.pageId"
      @click="showAddPageDialog = true"
    >
      <span class="align-center w-full flex-row justify-between gap-4">
        <OwnType
          v-if="pageName"
          :text="pageName"
          variant="title-regular"
          color="primary"
        />
        <PhPencilSimple class="misc-brand" size="24" />
      </span>
    </OwnOption>

    <OwnButton
      v-else
      class="w-full"
      :text="t('actions.add-page')"
      @click="showAddPageDialog = true"
    />

    <AddPageDialog
      v-if="showAddPageDialog"
      :edit-item="actionConfig"
      @update="onPageUpdate"
      @close="showAddPageDialog = false"
    />
  </div>
</template>

<script>
import { PhPencilSimple } from '@phosphor-icons/vue'
import { useI18n } from 'vue-i18n'

import { logError } from '@/logger'
import { OlympusClient } from '@/OlympusClient'
import { OwnButton } from '@/ui/OwnButton'
import { OwnOption } from '@/ui/OwnOption'
import { OwnType } from '@/ui/OwnType'

import AddPageDialog from '../../../../common/resource-dialogs/add-page-dialog/AddPageDialog.vue'

export default {
  name: 'PageForm',
  components: {
    AddPageDialog,
    OwnButton,
    OwnOption,
    OwnType,
    PhPencilSimple,
  },
  props: {
    actionConfig: { type: Object, default: null },
  },
  emits: ['update'],
  data() {
    return {
      isLoading: false,
      pageName: undefined,
      showAddPageDialog: false,
    }
  },
  created() {
    this.fetchPageName()
  },
  setup() {
    const { t } = useI18n()

    return { t }
  },
  methods: {
    async fetchPageName() {
      const { actionConfig } = this

      if (actionConfig.type !== 'page') return

      try {
        this.isLoading = true

        const result = await OlympusClient.funnel.v1.pages.page.getPage({
          params: {
            pageId: actionConfig.params.pageId,
          },
        })

        this.pageName = result.title
      } catch (error) {
        logError(error)
        this.pageName = this.t('unknownPage')
      } finally {
        this.isLoading = false
      }
    },
    onPageUpdate(selectedPage) {
      this.pageName = selectedPage.params.label

      this.$emit('update', selectedPage)
    },
  },
}
</script>
